import styled from '@emotion/styled';
import { css } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { getThemeColor, theme } from '@ezugi/ui/theme';

const { tints, typography } = theme;

const ITEM_HEIGHT = 40;

export const Ul = styled.ul`
  margin: 0;
  padding: 0;
  font-family: ${typography.font}, sans-serif;
  color: ${getThemeColor('foreground')};
  fill: ${getThemeColor('foreground')};
`;

export const Li = styled.li`
  position: relative;
  margin: 0;
  width: auto;
  height: ${ITEM_HEIGHT}px;
  transition: background-color 0.14s ease-in-out;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  ${({ color }) => color && `
    color: ${color};
    fill: ${color};
  `}

  &:hover {
    background-color: rgba(0, 0, 0, ${tints.darker});
  }
`;

export const itemWithDivider = css`
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    top: 0;
    left: 0;
    background-color: ${getThemeColor('foreground')};
    opacity: ${tints.divider};
  }
`;

const listParts = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${getThemeColor('foreground')};
  fill: ${getThemeColor('foreground')};
  flex-shrink: 0;
`;

export const Visual = styled.div`
  ${listParts};
  width: ${ITEM_HEIGHT}px;
  opacity: ${tints.primary};

  svg {
    color: ${getThemeColor('foreground')};
    fill: ${getThemeColor('foreground')};
  }
`;

export const Text = styled.div`
  flex-grow: 1;
  width: auto;
  height: auto;
  display: inline-grid;
`;

const commonTextRules = css`
  font-weight: normal;
  margin: 2px 0;
  padding: 0 ${SIZES.PADDING}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Primary = styled.h4`
  ${commonTextRules};
  font-size: 16px;
  opacity: ${tints.primary};
`;

export const Secondary = styled.h5`
  ${commonTextRules};
  font-size: 14px;
  opacity: ${tints.secondary};
`;

export const Action = styled.div`
  ${listParts};
  width: ${ITEM_HEIGHT}px;
  opacity: ${tints.primary};
  margin-left: auto;
`;
